import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "menu"
    }}>{`Menu`}</h1>
    <h2 {...{
      "id": "create-menu"
    }}>{`Create Menu`}</h2>
    <p>{`To Create at first, go to `}<inlineCode parentName="p">{`Appearance->Menus `}</inlineCode>{` and from that menu section and create your menu. Before saving the menu, make sure you clicked `}<inlineCode parentName="p">{`Cartsy Lite Main Menu`}</inlineCode>{` for that menu.`}</p>
    <p><img alt="1. set blog page" src={require("./images/menus/sc-01.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      